import { type ChangeEvent, createContext } from "react";

type ManagersContextData = {
	handleUpdateQuery(query: ChangeEvent<HTMLInputElement>): void;
	handleResetList(): void;
};

export const managersContext = createContext({} as ManagersContextData);
